export default {"src":"/uk/_next/static/media/noNetworkConnection.86fa78f4.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};